import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchModuleData } from '../redux/moduleDataSlice'
import { selectAuth } from '../redux/authSlice'
import { setSelectedRows } from '../redux/multiSelectRowSlice'

export default function Pagination({
  meta,
  setPartialLoad,
  baseName,
  paginateCallback,
  isCustomCall = false,
  setDataFunction = () => {},
}) {
  const dispatch = useDispatch()
  const [pageNumber, setPageNumber] = useState(meta.current_page || 1)

  const auth = useSelector(selectAuth)

  const handlePageInputChange = (evt) => {
    setPageNumber(evt.target.value)
  }
  const paginate = async (url) => {
    setPartialLoad(false)
    try {
      if (isCustomCall) {
        setDataFunction(url)

        dispatch(setSelectedRows({ selectedRows: [], isAll: false }))
      } else {
        await dispatch(
          fetchModuleData({
            accessToken: auth.accessToken,
            module_endpoint: url.replace(
              `${process.env.REACT_APP_API_DOMAIN}/`,
              ''
            ),
          })
        )
        dispatch(setSelectedRows({ selectedRows: [], isAll: false }))
      }
      setPartialLoad(true)
      document
        .getElementsByClassName('lox-layout-sidebar__content__main__wrapper')[0]
        .scroll(0, 0, 'smooth')
    } catch (error) {
      setPartialLoad(true)
    }
  }

  useEffect(() => {
    setPageNumber(meta.current_page)
  }, [meta.current_page])

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      if (
        pageNumber <= meta.last_page &&
        pageNumber >= 1 &&
        pageNumber !== meta.current_page
      ) {
        const url =
          meta.path +
          (meta.path.includes('?') ? '&' : '?') +
          `page=${pageNumber}`
        if (paginateCallback) {
          paginateCallback(url)
        } else {
          paginate(url)
        }
      }
    }, 1500)
    return () => clearTimeout(timeoutID)
  }, [pageNumber])

  const goToPage = (url) => {
    if (paginateCallback) {
      paginateCallback(url)
    } else {
      paginate(url)
    }
  }

  return (
    meta.links &&
    meta.links.length > 0 && (
      <div className="lox-table-pagination notification p-2">
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div className="lox-pagination-buttons buttons has-addons">
                {meta.links.map((link, index) => {
                  let label
                  if (link.label === 'Next &raquo;') {
                    label = 'Next'
                  } else if (link.label === '&laquo; Previous') {
                    label = 'Previous'
                  } else {
                    label = link.label
                  }
                  return (
                    <button
                      // Labels repeat ("..." gaps appear twice), so position is part of the key.
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${link.label}-${index}`}
                      disabled={!link.url}
                      type="button"
                      className={`button ${
                        link.active &&
                        'button has-background-primary has-text-white'
                      }`}
                      onClick={() => goToPage(link.url)}
                    >
                      {label}
                    </button>
                  )
                })}
              </div>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              {baseName !== 'rc_calling_recording' && (
                <small>
                  Page{' '}
                  <input
                    type="number"
                    min="1"
                    className="is-small py-0 is-fullheight"
                    style={{ width: '90px' }}
                    max={meta.last_page}
                    value={pageNumber}
                    onChange={handlePageInputChange}
                  />{' '}
                  of {meta.last_page}
                </small>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  )
}
